import React, { useEffect, useState } from "react";
//import { useStyles } from "./Notes.css";
import { useStyles } from "../ChoixDates/ChoixDates.css";
import { Alert } from "@material-ui/lab";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CharteModal from "../../connexion/modal/CharteModal";
import rest from "../../../rest";

import AffichageSelctDate, {
  sorteGroupeActivity,
} from "../ChoixDates/AfficheDateSelected";
import useRedirectAndReload from "../../general/redirectReload";
import useStylesThemes from "../../css/globalTheme";
import { useSelector } from "react-redux";

import { MySnackbar } from "../../../components/mySnackbar/MySnackbar";

const Notes = ({
  notesTH,
  setNotesTH,
  notesGeneral,
  setNotesGenerale,
  manifInfo,
  selectedValues,
  setActiveStep,
}) => {
  const redirectAndReload = useRedirectAndReload({
    url: "/planning.html",
    typeLink: "fromWishlistSelection",
  });
  const classes = useStyles();
  const styleTheme = useStylesThemes()();
  const [groupedActivities, setGroupedActivities] = useState({});
  const [openCharte, setOpenCharte] = useState(false);
  const [snack, setSnack] = useState({});

  const manifParams = useSelector((state) => state.manif.manifParams);

  const showPrevious = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    setGroupedActivities(sorteGroupeActivity(selectedValues));
  }, [selectedValues]);

  const finaliser = () => {
    // Extraction des parentNom uniques dans l'ordre
    const parentId = [
      ...new Set(selectedValues.map((tranche) => tranche.parentId)),
    ];

    // Création de la nouvelle collection avec les parentNom uniques
    const nouvelleCollection = parentId.map((id) => {
      const trancheAvecParentID = selectedValues.find(
        (tranche) => tranche.parentId === id
      );
      return {
        id: trancheAvecParentID ? trancheAvecParentID.parentId : null,
        nom: trancheAvecParentID ? trancheAvecParentID.parentNom : null,
        treated: false,
      };
    });

    let params = {
      selectedActivity: JSON.stringify(selectedValues),
      notesGeneral: notesGeneral,
      notesTH: notesTH,
      activity: JSON.stringify(nouvelleCollection),
    };
    rest
      .post("/activites/actionsv2/setWishList.json", params)
      .then((response) => {
        setSnack({
          message: response.data.message,
          show: true,
          severity: response.data.error ? "error" : "success",
        });
        if (response.data?.error === false) {
          redirectAndReload();
        }
      });
  };

  const handleOpenCharte = () => {
    setOpenCharte(true);
  };

  const handleCloseCharte = () => {
    setOpenCharte(false);
  };

  const handleChange = (event) => {
    var textfieldID = event.target.id;
    if (textfieldID === "vNoteTH") {
      setNotesTH(event.target.value);
    } else if (textfieldID === "vNoteGlobal") {
      setNotesGenerale(event.target.value);
    }
  };

  return (
    <>
      <MySnackbar params={snack} />
      <CharteModal
        open={openCharte}
        onClose={handleCloseCharte}
        onAccept={finaliser}
        charteUrl={manifParams.CharteBenevole}
        fallbackUrl="/gtexte.html?titre=CharteBenevole"
      />

      <React.Fragment>
        <main className={classes.content}>
          {manifInfo.TexteRemarque !== "" && (
            <Alert severity="warning" className={classes.alertCustom}>
              <div
                className={classes.alertContent}
                style={{ marginLeft: 8 }}
                dangerouslySetInnerHTML={{ __html: manifInfo.TexteRemarque }}
              />
            </Alert>
          )}
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card className={classes.card} elevation={3}>
                <CardContent className={classes.cardContent}>
                  <Typography
                    variant="h6"
                    className={classes.title}
                    style={{ marginBottom: 16 }}
                  >
                    Remarque générale
                  </Typography>
                  <TextField
                    id="vNoteGlobal"
                    placeholder="Remarque générale"
                    multiline
                    maxRows={10}
                    variant="outlined"
                    value={notesGeneral}
                    onChange={handleChange}
                    fullWidth
                  />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card
                className={classes.card}
                elevation={3}
                style={{ borderRadius: 8 }}
              >
                <CardContent>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography variant="h6" className={classes.title}>
                        Récapitulatif
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <Button
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={showPrevious}
                            className={styleTheme.secondarybutton}
                            style={{ marginRight: 8 }}
                          >
                            Retour
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            size="medium"
                            variant="contained"
                            color="secondary"
                            onClick={handleOpenCharte}
                            className={styleTheme.validateButton}
                          >
                            Finaliser
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <AffichageSelctDate
                    dataFrom={"selectionDates"}
                    groupedActivities={groupedActivities}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </main>
      </React.Fragment>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    manif: state.manif,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
